"use client";

import dynamic from "next/dynamic";
import DeferredMount from "@/components/ui/DeferredMount";

const HomeAboutThisChart = dynamic(
  () => import("@/components/pages/home/HomeAboutThisChart"),
  { ssr: false },
);

interface HomeAboutThisChartSlotProps {
  content: string;
}

export default function HomeAboutThisChartSlot({
  content,
}: HomeAboutThisChartSlotProps): React.ReactElement {
  return (
    <DeferredMount>
      <HomeAboutThisChart content={content} proseClassName="seo-copy-paragraphs" />
    </DeferredMount>
  );
}
